import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserModel } from '../users/shared/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUser: UserModel | null = null;

  constructor(private http: HttpClient) {}

  // Get CSRF cookie
  getCsrfCookie(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/sanctum/csrf-cookie`, { withCredentials: true });
  }

  // Login
  login(credentials: { email: string; password: string }): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/login`, credentials, { withCredentials: true }).pipe(
      tap((response: any) => {
        // store token in local storage
        localStorage.setItem('token', response.token);
        this.fetchUser(); // Fetch user after login
      }),
    );
  }

  fetchUser(): Observable<UserModel> {
    return this.http.get<UserModel>(`${environment.apiUrl}/api/me`, { withCredentials: true }).pipe(
      tap((user) => {
        this.currentUser = user;
      })
    );
  }

  getUser(): Observable<UserModel | null> {
    if (this.currentUser) {
      return new Observable((observer) => {
        observer.next(this.currentUser);
        observer.complete();
      });
    }
    return this.fetchUser();
  }

  // Logout
  logout(): void {
    this.http.post(`${environment.apiUrl}/api/logout`, {}, { withCredentials: true }).subscribe({
      next: () => {
        this.currentUser = null;
        localStorage.removeItem('token');
        window.location.href = '/login';
      },
    });
  }

  hasValidSession(): boolean {
    return !!localStorage.getItem('token');
  }
}
